<template>
  <div>
    <MaskModel :maskShow="maskShow" :width="500" @on-cancel="close">
      <div class="tip">提交需求</div>
      <div class="form">
        <i-form
          ref="formValidate"
          :model="formValidate"
          :rules="ruleValidate"
          :label-width="80"
        >
          <Form-item label="公司名称" prop="name">
            <i-input
              v-model="formValidate.name"
              placeholder="请输入公司名称"
            ></i-input>
          </Form-item>
          <Form-item label="联系人" prop="people">
            <i-input
              v-model="formValidate.people"
              placeholder="请输入联系人"
            ></i-input>
          </Form-item>
          <Form-item label="联系电话" prop="phone">
            <i-input
              v-model="formValidate.phone"
              placeholder="请输入联系电话"
            ></i-input>
          </Form-item>
          <Form-item label="咨询品种" prop="advisory">
            <i-input
              v-model="formValidate.advisory"
              placeholder="请输入咨询品种"
            ></i-input>
          </Form-item>
          <Form-item label="进口方式" prop="select">
            <i-select v-model="formValidate.select" placeholder="请选择">
              <i-option value="一次性进口">一次性进口</i-option>
              <i-option value="国际参比DTP">国际参比DTP</i-option>
            </i-select>
          </Form-item>
          <Form-item label="特殊备注" prop="desc">
            <i-input
              v-model="formValidate.desc"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 5 }"
              placeholder="请输入..."
            ></i-input>
          </Form-item>
          <Form-item>
            <i-button type="primary" @click="handleSubmit()" class="btn"
              >提交</i-button
            >
          </Form-item>
        </i-form>
      </div>
    </MaskModel>
  </div>
</template>

<script>
import MaskModel from "@/components/pc/MaskModel";
import { referenceDemand } from "@api/public";
export default {
  name: "ReferenceMask",
  props: ["maskShow"],
  components: {
    MaskModel
  },
  data() {
    var telCheck = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入联系人姓名"));
      } else {
        if (!/^1[3456789]\d{9}$/.test(value)) {
          callback(new Error("请输入正确手机号码"));
        } else {
          callback();
        }
      }
    };
    return {
      formValidate: {
        name: "",
        people: "",
        phone: "",
        advisory: "",
        select: "",
        desc: ""
      },
      ruleValidate: {
        name: [{ required: false, message: "", trigger: "blur" }],
        people: [
          { required: true, message: "联系人不能为空", trigger: "blur" }
        ],
        phone: [{ required: true, validator: telCheck, trigger: "blur" }],
        advisory: [
          { required: true, message: "请选择咨询品种", trigger: "blur" }
        ],
        select: [{ required: true, message: "请选择方式", trigger: "change" }],
        desc: [
          { required: false, message: "特殊备注", trigger: "blur" },
          {
            type: "string",
            min: 0,
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    handleSubmit() {
      this.$refs["formValidate"].validate(valid => {
        if (valid) {
          this.commitRequire();
        } else {
          this.$Message.error("表单验证失败!");
        }
      });
    },
    commitRequire() {
      referenceDemand(this.formValidate).then(res => {
        if (res.status === 200) {
          this.$Modal.success({
            content: res.msg
          });
        }
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.contact-box /deep/ .ivu-form-item
  margin-bottom 20px

.tip
  height 44px
  font-size 26px
  color #555
.form
  padding 20px 70px 0 30px
  .btn
    padding 5px 50px
</style>
